import {getMappedCellData} from '@/helpers/onlineOrderUtility'
import {DynamicColumnTable} from '@/components/organisms'
import {useOnlineOrderData} from '@/services/onlineOrderService'
import {useState} from 'react'

export const OnlineOrderList = () => {
  const [pageRowSelection, setPageRowSelection] = useState({})
  const {rowData, colConfig, isLoading, isError} = useOnlineOrderData()

  if (isError) {
    return <span>Error Loading the data from API</span>
  }

  if (isLoading) {
    return <span>Loading Table Data</span>
  }

  const cellDataMappedCols = getMappedCellData(colConfig)
  return (
    <DynamicColumnTable
      pklass={`dynamic-table hide-col-sort font-normal text-balance`}
      columns={cellDataMappedCols}
      records={rowData || []}
      isDark={true}
      tableDescription=""
      tableHeader=""
      rowSelection={pageRowSelection}
      setRowSelection={setPageRowSelection}
      commonCellDataCheck={true}
      toolbarActions={[
        {
          text: 'Download',
          variant: 'primary',
          onClick: () => {},
        },
      ]}
    />
  )
}
